export enum LeadPhoneType {
  Landline = 'landline',
  Mobile = 'mobile',
  Voip = 'voip',
  Unknown = 'unknown',
}
